import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, flatMap, map, switchMap } from 'rxjs/operators';
import { CalcTypeService } from '../../../lookups/calc-type.service';
import * as fromShared from '../../../shared';
import { DisplayMessageMinimum, ResponseStatus } from '../../../shared';
import { AccountAllocationsService } from '../account-allocations.service';
import * as AccountAllocationsActions from './account-allocation.actions';

@Injectable()
export class AccountAllocationsEffects {
    getExpenseTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountAllocationsActions.getExpenseTypes),
            switchMap(() =>
                // this.calcTypeService.getCalcType('expense').pipe(
                this.calcTypeService.getCalcType().pipe(
                    flatMap(resp => [
                        AccountAllocationsActions.loadExpenseTypes({
                            expenseTypes: resp.filter(x => !!x.CostSubType)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    getAccountAllocations$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountAllocationsActions.getAccountAllocations),
            switchMap(action =>
                this.service.get().pipe(
                    flatMap(resp => [
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        r =>
                                            r.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        ),
                        AccountAllocationsActions.loadAccountAllocations({
                            accountAllocations: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    putAccountAllocationsStatus$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountAllocationsActions.putAccountAllocations),
            map(action =>
                AccountAllocationsActions.upsertAccountAllocations({
                    accountAllocations: action.accountAllocations.map(x => ({
                        ...x,
                        Status: {
                            StatusCode: ResponseStatus.Loading,
                            Message: 'Loading'
                        }
                    }))
                })
            )
        );
    });
    putAccountAllocations$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountAllocationsActions.putAccountAllocations),
            switchMap(action =>
                this.service.put(action.accountAllocations).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  AccountAllocationsActions.upsertAccountAllocations(
                                      {
                                          accountAllocations: resp.Items
                                      }
                                  ),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.Accountlistid.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  AccountAllocationsActions.upsertAccountAllocations(
                                      {
                                          accountAllocations: resp.Items
                                      }
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    constructor(
        private actions$: Actions,
        private service: AccountAllocationsService,
        private calcTypeService: CalcTypeService
    ) {}
}
